// eslint-disable-next-line import/prefer-default-export
export const salaryFrequency = {
  ANNUAL: {
    label: 'Annual',
    conversion: amount => amount,
  },
  MONTHLY: {
    label: 'Monthly',
    conversion: amount => amount * 12,
  },
  WEEKLY: {
    label: 'Weekly',
    conversion: amount => amount * 4 * 12,
  },
  EVERY_SECOND_WEEK: {
    label: 'Every second week',
    conversion: amount => amount * 2 * 12,
  },
};
